import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import deCommon from './locales/de/common.json';
import deNavigation from './locales/de/navigation.json';
import deAssets from './locales/de/assets.json';
import deAuth from './locales/de/auth.json';
import dePages from './locales/de/pages.json';
import deSettings from './locales/de/settings.json';
import deBranch from './locales/de/branch.json';

import enCommon from './locales/en/common.json';
import enNavigation from './locales/en/navigation.json';
import enAssets from './locales/en/assets.json';
import enAuth from './locales/en/auth.json';
import enPages from './locales/en/pages.json';
import enSettings from './locales/en/settings.json';
import enBranch from './locales/en/branch.json';

import srCommon from './locales/sr/common.json';
import srNavigation from './locales/sr/navigation.json';
import srAssets from './locales/sr/assets.json';
import srAuth from './locales/sr/auth.json';
import srPages from './locales/sr/pages.json';
import srSettings from './locales/sr/settings.json';
import srBranch from './locales/sr/branch.json';

const resources = {
  de: {
    common: deCommon,
    navigation: deNavigation,
    assets: deAssets,
    auth: deAuth,
    pages: dePages,
    settings: deSettings,
    branch: deBranch,
  },
  en: {
    common: enCommon,
    navigation: enNavigation,
    assets: enAssets,
    auth: enAuth,
    pages: enPages,
    settings: enSettings,
    branch: enBranch,
  },
  sr: {
    common: srCommon,
    navigation: srNavigation,
    assets: srAssets,
    auth: srAuth,
    pages: srPages,
    settings: srSettings,
    branch: srBranch,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    defaultNS: 'common',
    fallbackLng: 'de',
    lng: localStorage.getItem('app_language') || 'de',
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    
    debug: false,
  });

export default i18n;
